// Convert VAPID public key from base64 to Uint8Array
function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/")
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

const headers = {
  "Content-Type": "application/json",
}

export async function ensureClientPushSubscription() {
  if ("serviceWorker" in navigator && "PushManager" in window) {
    try {
      const registration = await navigator.serviceWorker.ready

      const existingSubscription =
        await registration.pushManager.getSubscription()
      if (existingSubscription) {
        return
      }

      if (Notification.permission !== "granted") {
        return
      }

      const publicKey = await fetch("/api/PushNotification/GetPublicKey", {
        method: "GET",
        headers,
      }).then((response) => response.text())

      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      })

      await fetch("/api/PushNotification/subscribe", {
        method: "POST",
        headers,
        body: JSON.stringify(subscription),
      })
    } catch (error) {
      console.error("Error subscribing user:", error)
    }
  }
}

export async function unsubscribeClientToPushNotification() {
  if ("serviceWorker" in navigator && "PushManager" in window) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations()
      // in some cases there might be a service worker but no registrations, and then navigator.serviceWorker.ready hangs
      if (registrations.length === 0) {
        return
      }
      const registration = await navigator.serviceWorker.ready

      const existingSubscription =
        await registration.pushManager.getSubscription()
      if (existingSubscription) {
        await existingSubscription.unsubscribe()
        await fetch("/api/PushNotification/unsubscribe", {
          method: "POST",
          headers,
          body: JSON.stringify(existingSubscription.endpoint),
        })
      }
    } catch (error) {
      console.error("Error unsubscribing user:", error)
    }
  }
}

export async function getClientPushSubscription() {
  if ("serviceWorker" in navigator && "PushManager" in window) {
    try {
      const registration = await navigator.serviceWorker.ready
      return await registration.pushManager.getSubscription()
    } catch (error) {
      console.error("Error getting push subscriptions: ", error)
    }
  }
  return null
}
